import { RiderVehicleTypeEnum, XpressDeliveryStatus, XpressUserRoleEnum } from 'app/models';
import { PayServiceTypeEnum } from 'app/models/enums/payment-method.enum';
import { RiderGroupEnum } from 'app/models/enums/rider-group.enum';
import { DriverCampaignType } from 'app/models/enums/driver-campaign-type.enum';

export class ActiveOrdersModel {
    public static BookingRideTabMenuList: Array<any> = [
        { id: RiderVehicleTypeEnum.None, label: 'All' },
        { id: RiderVehicleTypeEnum.Moto, label: 'Moto' },
        { id: RiderVehicleTypeEnum.Sedan, label: 'Car' },
		{ id: RiderVehicleTypeEnum.SUV, label: 'SUV' },
		{ id: RiderVehicleTypeEnum.Taxi, label: 'Taxi' },
    ];

    public static BookingSendTabMenuList: Array<any> = [
        { id: RiderVehicleTypeEnum.None, label: 'All' },
        { id: RiderVehicleTypeEnum.None, label: '20kg' },
        { id: RiderVehicleTypeEnum.None, label: '100kg' },
        { id: RiderVehicleTypeEnum.None, label: '500kg' }
    ];

    public static BookingDeliveryTabMenuList: Array<any> = [
        { id: RiderVehicleTypeEnum.None, label: 'All' }
    ];

    public static BookingRentTabMenuList: Array<any> = [
        { id: RiderVehicleTypeEnum.None, label: 'All' }
    ];

    public static BookingPetTaxiTabMenuList: Array<any> = [
        { id: RiderVehicleTypeEnum.None, label: 'All' }
    ];

    public static BookingTransfersTabMenuList: Array<any> = [
        { id: RiderVehicleTypeEnum.None, label: 'All' }
    ];

    public static BookingStatusList: Array<any> = [
        { name: 'All', value: null, roleId: null },
        { name: 'Requesting', value: [XpressDeliveryStatus.New, XpressDeliveryStatus.RiderAssigning], roleId: null },
        { name: 'Assigned', value: [XpressDeliveryStatus.RiderAssigned], roleId: null },
        { name: 'Assigned Back To Back', value: [XpressDeliveryStatus.RiderAcceptB2B], roleId: null },
        { name: 'Accepted', value: [XpressDeliveryStatus.RiderAccept], roleId: null },
        { name: 'Picking Up', value: [XpressDeliveryStatus.ArrivedToPickup], roleId: null },
        { name: 'On Trip', value: [XpressDeliveryStatus.PickedUp, XpressDeliveryStatus.ArrivedToDrop], roleId: null },
        { name: 'Completed', value: [XpressDeliveryStatus.Completed], roleId: null },
        { name: 'Cancelled', value: [XpressDeliveryStatus.Canceled], roleId: null },
        { name: 'Rejected', value: [XpressDeliveryStatus.Rejected], roleId: null },
        { name: 'Admin Cancelled', value: [XpressDeliveryStatus.Canceled], roleId: XpressUserRoleEnum.Admin },
        { name: 'Customer Cancelled', value: [XpressDeliveryStatus.Canceled], roleId: XpressUserRoleEnum.User },
        { name: 'Driver Cancelled', value: [XpressDeliveryStatus.Canceled], roleId: XpressUserRoleEnum.Rider },
        { name: 'Unallocated', value: [XpressDeliveryStatus.Canceled], roleId: XpressUserRoleEnum.None }
    ];

    public static BookingPaymentMethodList: Array<any> = [
        { value: PayServiceTypeEnum.None, name: 'All' },
        { value: PayServiceTypeEnum.Cash, name: 'Cash' },
        { value: PayServiceTypeEnum.PaymentCard, name: 'Payment Card' },
        { value: PayServiceTypeEnum.ForCompany, name: 'For Company' },
        { value: PayServiceTypeEnum.XpressUserWallet, name: 'Xpay' },
        { value: PayServiceTypeEnum.FullPromo, name: 'Full Promo' },
        { value: PayServiceTypeEnum.RecipientPaysForDelivery, name: 'Recipient pays for delivery' },
    ];

    public static RiderGroupsList: Array<any> = [
        { value: RiderGroupEnum.None, name: 'All' },
        { value: RiderGroupEnum.Moto, name: 'General Motorcycle Riders' },
        { value: RiderGroupEnum.Car, name: 'General Car Drivers' },
    ];

    public static BookingRiderCompanyList: Array<any> = [
        { value: DriverCampaignType.None, name: 'All' },
        { value: DriverCampaignType.CampaignDriver, name: 'Campaign Driver' },
        { value: DriverCampaignType.Xpress50, name: 'Xpress 50' },
        { value: DriverCampaignType.Xpress50Rider4W, name: '4RXP' },
        { value: DriverCampaignType.Boracay, name: 'Boracay' },
        { value: DriverCampaignType.Xpress2WEV, name: '2W EV' },
        { value: DriverCampaignType.Xpress4WEV, name: '4W EV' },
        { value: DriverCampaignType.AllanGroup, name: 'Allan Group' },
        { value: DriverCampaignType.NiloGroup, name: 'Nilo Group' }
    ];

    public static BookingLabelList: Array<{ name: string; value: string }> = [
        { name: 'Primary', value: 'Primary' },
        { name: 'Back To Back', value: 'Back To Back' },
    ];
}
